import { useContext } from "react"
import AppInfoContext from "src/provider/state-manager/appInfoProvider"

function SvgComponent(props: any) {
    const {info: {theme}} = useContext(AppInfoContext)

    return (
        <svg
            width={58}
            height={58}
            viewBox="0 0 58 58"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
        <rect width={58} height={58} rx={29} fill={props.isHover ? theme["#0D968F"] : "#F7FEFD"} />
        <path
            d="M36.17 23.64c-.43-2.17-2.04-3.12-4.28-3.12h-8.78c-2.64 0-4.4 1.32-4.4 4.4v5.15c0 2.22.91 3.52 2.41 4.08.22.08.46.15.71.19.4.09.83.13 1.28.13h8.79c2.64 0 4.4-1.32 4.4-4.4v-5.15c0-.47-.04-.89-.13-1.28zM22.53 29c0 .41-.34.75-.75.75s-.75-.34-.75-.75v-3c0-.41.34-.75.75-.75s.75.34.75.75v3zm4.97 1.14c-1.46 0-2.64-1.18-2.64-2.64 0-1.46 1.18-2.64 2.64-2.64 1.46 0 2.64 1.18 2.64 2.64 0 1.46-1.18 2.64-2.64 2.64zM33.96 29c0 .41-.34.75-.75.75s-.75-.34-.75-.75v-3c0-.41.34-.75.75-.75s.75.34.75.75v3z"
            fill={props.isHover ? '#F7FEFD' : theme["#0D968F"]}
        />
        <path
            d="M39.3 27.92v5.15c0 3.08-1.76 4.41-4.41 4.41h-8.78c-.75 0-1.42-.11-2-.33-.47-.17-.88-.42-1.21-.74-.18-.17-.04-.44.21-.44h8.78c3.7 0 5.9-2.2 5.9-5.89v-5.16c0-.24.27-.39.44-.21.68.72 1.07 1.77 1.07 3.21z"
            fill={props.isHover ? '#F7FEFD' : theme["#0D968F"]}
        />
        </svg>
    )
}

export default SvgComponent